// import './ghtSchedule.css';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, NavItem, Table } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { authKey, GET_SCHEDULE_NO_LIST, GET_WEEKLY_SCHEDULE_PLAN_BY_SCHEDULE_NO, SCHEDULE_PLANNING_NO_LIST, GET_STAKEHOLDER_CATEGORY, PRINT_DOWNLOAD_DATA, APPROVE_STAKEHOLDER_SCHEDULE, WEEKLY_SCHEDULE_PLAN_BY_PLANNING_NO } from '../../../common/URLs';
import jwt from 'jwt-decode';
import DatePicker from "react-datepicker";
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import moment from 'moment';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD } from '../../../common/constants';
// import { Dialog, DialogActions, DialogContent } from "@mui/material";
// import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import { toast } from "react-toastify";
import { Typography, IconButton, Tooltip, Tab, Container, Card, CardContent, Box, Grid, TextField, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { useTranslation } from "react-i18next";
import { PrintIcon, SearchIcon, ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";

function PlantSchedule(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const decoded = jwt(getLocalStorageItem('id_token'));
  const location = useLocation();
  const state = useLocation().state;
  const [scheduleno, setScheduleno] = useState([]);
  const [weeklyscheduledata, setWeeklyscheduledata] = useState([]);
  const [stakeholderType, setStakeholderType] = useState("");
  const [stakeholderDetails, setStakeholderDetails] = useState();
  const [hideHarvesting, setHideHarvesting] = useState();
  const [selectedUrn, setSelectedUrn] = useState();
  const [selectedRows, setSelectedRows] = useState();
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date(fromDate.getTime() + 7 * 24 * 60 * 60 * 1000));
  const [printHarvestingInstruction, setPrintHarvestingInstruction] = useState();
  const [monthChange, setMonthChange] = useState(useLocation().state?.month);


  const [tabValue, setTabValue] = React.useState(state?.tabValue ? state?.tabValue : "Grower");

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === "Chipping") {
      getWeeklySchedule({ target: { value: getScheduleNo[0] } }, searchFilter?.weeklyScheduleNumber, newValue)
    } else {
      getWeeklySchedule(event, searchFilter?.weeklyScheduleNumber, newValue)
    }
  };

  const [searchFilter, setSearchFilter] = useState({
    "weeklyScheduleNumber": String(useLocation().state?.planningNumber ?? ""),
    "weekNumber": String(useLocation().state?.weekNumber ?? ""),
  });

  const [errorMessage, setErrorMessage] = useState({
    "weeklyScheduleNumberError": "",
    "weekNumberError": "",
    "monthError": ""
  });

  const harvestingDetails = (cellValues) => {

    navigate('./harvestingDetails', {
      state: { selectedRow: cellValues.row }
    });
  }
  useEffect(() => {
    setSelectedUrn(location?.state?.data);
    // console.log("test");
    if (location?.state?.data) {
      getStakeDetails(location?.state?.data?.urn)
    } else {
      getStakeDetails(decoded.extension_URN ? decoded.extension_URN : 'plant')
    }

  }, []);

  useEffect(() => {
    if (scheduleno && scheduleno.length > 0)
      getWeeklySchedule(null, scheduleno[0]);
  }, [stakeholderDetails, scheduleno])


  function getStakeDetails(urn) {
    loaderService.showLoader()
    apiClient
      .post(GET_STAKEHOLDER_CATEGORY,
        {
          "urn": urn,
          "type": ""
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setStakeholderDetails(response.data);
        //getWeeklySchedule(null, scheduleno[0]);
        getScheduleNo();
        loaderService.hideLoader()
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  useEffect(() => {
    getScheduleNo();
  }, []);

  const getScheduleNo = () => {
    loaderService.showLoader()
    apiClient
      .post(SCHEDULE_PLANNING_NO_LIST,
        {},
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setScheduleno(response.data.schedulePlanningNoList);
        //getWeeklySchedule({ target: { value: response.data.scheduleNoList[0] } });
        !state?.planningNumber && setSearchFilter({ "weeklyScheduleNumber": response.data.schedulePlanningNoList[0] })
        loaderService.hideLoader()
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }
  const getWeeklySchedule = (e, serachvalue, tabUpdate) => {
    let tabVal = tabUpdate ? tabUpdate : tabValue
    loaderService.showLoader()
    let activity = "";
    let stakeHolderType = "";

    if (tabVal === "Grower") {
      activity = '';
      stakeHolderType = "Grower"
    }
    if (tabVal === "HIT") {
      activity = '';
      stakeHolderType = "HIT"
    }

    if (tabVal === "LLEChipping") {
      activity = 'chipping';
      stakeHolderType = "LLE"
    }
    if (tabVal === "LLELoading") {
      activity = 'loading';
      stakeHolderType = "LLE"
    }
    if (tabVal === "LLEUnloading") {
      activity = 'unloading';
      stakeHolderType = "LLE"
    }

    if (tabVal === "PlantChipping") {
      activity = 'chipping';
      stakeHolderType = "Plant"
    }
    if (tabVal === "PlantUnloading") {
      activity = 'unloading';
      stakeHolderType = "Plant"
    }
    if (tabVal === "Transporter") {
      activity = '';
      stakeHolderType = "Transporter"
    }
    if (tabVal === "InterimStorage") {
      activity = '';
      stakeHolderType = "InterimStorage"
    }

    apiClient
      .post(WEEKLY_SCHEDULE_PLAN_BY_PLANNING_NO,
        {
          "planningNumber": searchFilter?.weeklyScheduleNumber,
          "stakeHolderType": stakeHolderType,
          "month": monthChange,
          "weekNumber": searchFilter?.weekNumber,
          "activityType": activity
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setWeeklyscheduledata(response.data.weeklySchedulePlanDetailsList);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const handleChange = (e) => {
    console.log(e.target.value);
    setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value });

    if (e.target.name === "weeklyScheduleNumber") {
      setErrorMessage({ ...errorMessage, weeklyScheduleNumberError: "" });
    }
    if (e.target.name === "weekNumber") {
      setErrorMessage({ ...errorMessage, weekNumberError: "" });
    }
  }

  function searchScheduleDetails(e) {
    e.preventDefault();
    if (!searchFilter?.weeklyScheduleNumber) {
      setErrorMessage({ ...errorMessage, weeklyScheduleNumberError: "Please select Planning Number" })
    }
    else if (!monthChange) {
      setErrorMessage({ ...errorMessage, monthError: "Please select Month" })
    }
    else if (!searchFilter?.weekNumber) {
      setErrorMessage({ ...errorMessage, weekNumberError: "Please select Week Number" })
    }
    else {
      getWeeklySchedule(e, searchFilter.weeklyScheduleNumber, tabValue);
    }

  }


  const columns = [
    { field: 'weeklyScheduleNumber', headerName: 'Schedule No', width: 250 },
    { field: 'scheduleLineNumber', headerName: 'Schedule Line No', width: 150 },
    {
      field: 'schedulePickupDate', headerName: 'Pick up Date', width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    { field: 'scheduleRbCbQuantity', headerName: 'Quantity(MT)', width: 150 },
    {
      field: 'firstPartyUrn', headerName: 'Source URN', width: 150,
      renderCell: (cellValues) => {
        return (
          stakeholderDetails?.category === "Grower" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderUrn : cellValues?.row?.firstPartyUrn}</>
            :
            <> {cellValues?.row?.firstPartyUrn} </>
        );
      }
    },
    {
      field: 'firstPartyContactNo', headerName: 'Source Contact Details', width: 160,
      renderCell: (cellValues) => {
        return (
          stakeholderDetails?.category === "Grower" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderContactNo : cellValues?.row?.firstPartyContactNo}</>
            :
            <> {cellValues?.row?.firstPartyContactNo} </>
        );
      }
    },
    {
      field: 'firstPartyName', headerName: 'Source Name', width: 170,
      renderCell: (cellValues) => {
        return (
          stakeholderDetails?.category === "Grower" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.scheduleStakeholderName : cellValues?.row?.firstPartyName}</>
            :
            <> {cellValues?.row?.firstPartyName} </>
        );
      }
    },
    { field: 'secondPartyUrn', headerName: 'Destination URN', width: 150 },
    { field: 'secondPartyContactNo', headerName: 'Destination Contact Details', width: 160 },
    { field: 'secondPartyName', headerName: 'Destination Name', width: 170 },
    {
      field: 'scheduledDeliveryDate', headerName: 'Delivery Date', width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
    },
    { field: 'poStpoNumber', headerName: 'PO Number', width: 150 },
    { field: 'landId', headerName: 'Land ID', width: 150, hide: stakeholderDetails?.category != "HIT" },
    { field: 'inventoryType', headerName: 'Type of Inventory', width: 150 },

    {
      field: 'isScheduledApproved', headerName: 'Approval Status', width: 150,
      valueFormatter: (params) => {
        if (params.value === true) {
          return 'Approved';
        }
        else if (params.value === false) {
          return 'Not Approved';
        }
        else {
          return '';
        }
      },
      // getCellValue: (params) => {
      //     if (params?.row?.scheduleStakeholderType === stakeholderDetails?.category) {
      //      return <>{params?.row?.isScheduledApproved}</>;
      //     } else if (params?.row?.firstPartyType === stakeholderDetails?.category) {
      //      return <>{params?.row?.isFirstPartyApproved}</>;
      //     } else {
      //      return <>{params?.row?.isSecondPartyApproved}</>;
      //     }
      //    },
    },

  ];

  const lleChippingColumns = [
    { field: 'weeklyScheduleNumber', headerName: 'Schedule No', width: 280 },
    { field: 'scheduleLineNumber', headerName: 'Schedule Line No', width: 200 },
    {
      field: 'schedulePickupDate', headerName: t('reg.date'), width: 220,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    { field: 'scheduleRbCbQuantity', headerName: 'Quantity for Chipping', width: 200 },
    { field: 'status', headerName: 'Approval Status', width: 200 },
  ];

  const lleColumnsLoadingUnloading = [
    { field: 'weeklyScheduleNumber', headerName: 'Schedule No', width: 250 },
    { field: 'scheduleLineNumber', headerName: 'Schedule Line No', width: 150 },
    {
      field: 'schedulePickupDate', headerName: 'Pick up Date', width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    { field: 'scheduleRbCbQuantity', headerName: 'Quantity (MT)', width: 150 },
    {
      field: 'stakeholderUrn', headerName: 'Source URN', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"),
      renderCell: (cellValues) => {
        return (
          tabValue === "Loading" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderUrn : cellValues?.row?.firstPartyUrn}</>
            :
            <> {cellValues?.row?.firstPartyUrn} </>
        );
      }
    },
    {
      field: 'stakeholderContactNo', headerName: 'Source Contact Details', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"),
      renderCell: (cellValues) => {
        return (
          tabValue === "Loading" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderContactNo : cellValues?.row?.firstPartyContactNo}</>
            :
            <> {cellValues?.row?.firstPartyContactNo} </>
        );
      }
    },
    {
      field: 'firstPartyName', headerName: 'Source Name', width: 170, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"), renderCell: (cellValues) => {
        return (
          tabValue === "Loading" ?
            <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.scheduleStakeholderName : cellValues?.row?.firstPartyName}</>
            :
            <> {cellValues?.row?.firstPartyName} </>
        );
      }
    },
    {
      field: 'secondPartyUrn', headerName: 'Destination URN', width: 150,
      renderCell: (cellValues) => {
        return (
          tabValue === "Unloading" ?
            <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderUrn : cellValues?.row?.secondPartyUrn}</>
            :
            <> {cellValues?.row?.secondPartyUrn} </>
        );
      }
    },
    {
      field: 'secondPartyContactNo', headerName: 'Destination Contact Details', width: 150,
      renderCell: (cellValues) => {
        return (
          tabValue === "Unloading" ?
            <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderContactNo : cellValues?.row?.secondPartyContactNo}</>
            :
            <> {cellValues?.row?.secondPartyContactNo} </>
        );
      }
    },
    {
      field: 'secondPartyLocationName', headerName: 'Destination Name', width: 170,
      renderCell: (cellValues) => {
        return (
          tabValue === "Unloading" ?
            <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.scheduleStakeholderName : cellValues?.row?.secondPartyName}</>
            :
            <> {cellValues?.row?.secondPartyName} </>
        );
      }
    },
    {
      field: 'scheduledDeliveryDate', headerName: 'Delivery Date', width: 150,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
    },
    { field: 'poStpoNumber', headerName: 'PO Number', width: 150 },
    { field: 'inventoryType', headerName: 'Type of Inventory', width: 150 },
    { field: 'status', headerName: 'Approval Status', width: 200 },
    {
      field: 'Navigate', headerName: 'Navigate', width: 200, hide: stakeholderDetails?.category != "HIT",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="View Harvesting Details">
            <IconButton color="primary"
              onClick={() => harvestingDetails(cellValues)}>
              <ViewIcon />
            </IconButton>
          </Tooltip>
        );
      }
    },
    {
      field: 'Print', headerName: "Print", width: 200, hide: stakeholderDetails?.category != "HIT",
      renderCell: () => {
        return (
          <Tooltip title=" Print Harvesting Instruction">
            <IconButton color="primary">
              <PrintIcon />
            </IconButton>
          </Tooltip>
        );
      }
    }
  ];

  const printHarvestInstructions = (action, cellValues) => {
    loaderService.showLoader();
    apiClient
      .post(PRINT_DOWNLOAD_DATA,
        {
          "printDataByNumber": cellValues?.row?.id,
          "printDetailsType": "weekly_schedule",
        },
        {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),

            Accept: 'application/pdf'
          }
        }, null
      )
      .then((response) => {
        setPrintHarvestingInstruction(response.data);
        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        if (action === "print") {
          let iframe = document.createElement('iframe');
          document.body.appendChild(iframe);
          iframe.style.display = 'none';
          iframe.src = url;
          iframe.onload = function () {
            setTimeout(function () {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          };
        }
        loaderService.hideLoader();
      }).catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const onMonthChange = (e) => {
    setMonthChange(e.target.value);
    setErrorMessage({ ...errorMessage, monthError: "" });
  }

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT48</p>}
        <Typography variant="h5" gutterBottom>
          Weekly Pick-Up Plan
        </Typography>
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} lg={12}>
                    <Typography variant="subtitle1">Fiscal Year : {weeklyscheduledata?.[0]?.year}</Typography>
                  </Grid>
                  {/* <Grid item xs={12} lg={6}>
                    <Typography variant="subtitle1">Month : {weeklyscheduledata?.[0]?.month}</Typography>
                  </Grid> */}
                  <Grid item xs={12} lg={3} mt={1}>
                    <FormControl fullWidth size="small" required error={errorMessage.weeklyScheduleNumberError}>
                      <InputLabel>Planning Number</InputLabel>
                      <Select label='Planning Number' name="weeklyScheduleNumber" value={searchFilter?.weeklyScheduleNumber} onChange={(e) => handleChange(e)}>
                        {/* <MenuItem selected={searchFilter?.weeklyScheduleNumber ? true : false}>select</MenuItem> */}
                        {scheduleno.map(
                          (schNo, index) => {
                            return <MenuItem selected={index === 0 ? true : false} value={schNo}>{schNo}</MenuItem>
                          }
                        )
                        }
                      </Select>
                      <FormHelperText sx={{ color: 'red' }}>{errorMessage.weeklyScheduleNumberError}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={3} mt={1}>
                    <FormControl fullWidth size="small" required error={errorMessage.monthError}>
                      <InputLabel>Month</InputLabel>
                      <Select required label="Month" value={monthChange || ''} name="month" onChange={(e) => onMonthChange(e)}>
                        <MenuItem><em>Month</em></MenuItem>
                        <MenuItem value="Jan">January</MenuItem>
                        <MenuItem value="Feb">February</MenuItem>
                        <MenuItem value="Mar">March</MenuItem>
                        <MenuItem value="Apr">April</MenuItem>
                        <MenuItem value="May">May</MenuItem>
                        <MenuItem value="Jun">June</MenuItem>
                        <MenuItem value="Jul">July</MenuItem>
                        <MenuItem value="Aug">August</MenuItem>
                        <MenuItem value="Sep">September</MenuItem>
                        <MenuItem value="Oct">October</MenuItem>
                        <MenuItem value="Nov">November</MenuItem>
                        <MenuItem value="Dec">December</MenuItem>
                      </Select>
                      <FormHelperText sx={{ color: 'red' }}>{errorMessage.monthError}</FormHelperText>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} lg={3} mt={1}>
                    <FormControl fullWidth size="small" required error={errorMessage.weekNumberError}>
                      <InputLabel>Week Number</InputLabel>
                      <Select label='Week Number' name="weekNumber" value={searchFilter?.weekNumber} onChange={(e) => handleChange(e)}>
                        <MenuItem value="" selected>Select</MenuItem>
                        <MenuItem value="1">1</MenuItem>
                        <MenuItem value="2">2</MenuItem>
                        <MenuItem value="3">3</MenuItem>
                        <MenuItem value="4">4</MenuItem>
                        <MenuItem value="5">5</MenuItem>
                      </Select>
                      <FormHelperText sx={{ color: 'red' }}>{errorMessage.weekNumberError}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={3} mt={1}>
                    <Button style={{ float: "right" }} startIcon={<SearchIcon />} variant="contained" color="primary" onClick={(e) => searchScheduleDetails(e)}>Search </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Card sx={{ mt: 2 }}>
          <TabContext value={tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'whitesmoke' }}>
              <TabList onChange={handleTabChange} aria-label="lab API tabs example" variant="scrollable">
                <Tab label="Grower" value="Grower" />
                <Tab label="HIT" value="HIT" />
                <Tab label="Transporter" value="Transporter" />
                <Tab label="IS" value="InterimStorage" />
                <Tab label="LLE Chipping" value="LLEChipping" />
                <Tab label="LLE Loading" value="LLELoading" />
                <Tab label="LLE Unloading" value="LLEUnloading" />
                <Tab label="Plant Chipping" value="PlantChipping" />
                <Tab label="Plant Unloading" value="PlantUnloading" />
              </TabList>
            </Box>
            <TabPanel value="Grower" >
              <Box style={{ height: 400, width: '100%' }}>
                {
                  weeklyscheduledata &&
                  <DataGrid rows={weeklyscheduledata}
                    columns={columns}
                    pageSize={5}
                    components={{ Toolbar: QuickSearchToolbar }}
                  />

                }
              </Box>
            </TabPanel>
            <TabPanel value="HIT" >
              <Box style={{ height: 400, width: '100%' }}>
                {
                  weeklyscheduledata &&
                  <DataGrid rows={weeklyscheduledata}
                    columns={columns}
                    pageSize={5}
                    components={{ Toolbar: QuickSearchToolbar }}
                  />

                }
              </Box>
            </TabPanel>
            <TabPanel value="Transporter" >
              <Box style={{ height: 400, width: '100%' }}>
                {
                  weeklyscheduledata &&
                  <DataGrid rows={weeklyscheduledata}
                    columns={columns}
                    pageSize={5}
                    components={{ Toolbar: QuickSearchToolbar }}
                  />

                }
              </Box>
            </TabPanel>
            <TabPanel value="InterimStorage" >
              <Box style={{ height: 400, width: '100%' }}>
                {
                  weeklyscheduledata &&
                  <DataGrid rows={weeklyscheduledata}
                    columns={columns}
                    pageSize={5}
                    components={{ Toolbar: QuickSearchToolbar }}
                  />

                }
              </Box>
            </TabPanel>
            <TabPanel value="LLEChipping" >
              <Box style={{ height: 400, width: '100%' }}>
                {
                  weeklyscheduledata &&
                  <DataGrid rows={weeklyscheduledata}
                    columns={lleChippingColumns}
                    pageSize={5}
                    components={{ Toolbar: QuickSearchToolbar }}
                  />

                }
              </Box>

            </TabPanel>
            <TabPanel value="LLELoading" >
              <Box style={{ height: 400, width: '100%' }}>
                {
                  weeklyscheduledata &&
                  <DataGrid rows={weeklyscheduledata}
                    columns={lleColumnsLoadingUnloading}
                    pageSize={5}
                    components={{ Toolbar: QuickSearchToolbar }}
                  />

                }
              </Box>
            </TabPanel>
            <TabPanel value="LLEUnloading">
              <Box style={{ height: 400, width: '100%' }}>
                {
                  weeklyscheduledata &&
                  <DataGrid rows={weeklyscheduledata}
                    columns={lleColumnsLoadingUnloading}
                    pageSize={5}
                    components={{ Toolbar: QuickSearchToolbar }}
                  />

                }
              </Box>
            </TabPanel>
            <TabPanel value="PlantChipping" >
              <Box style={{ height: 400, width: '100%' }}>
                {
                  weeklyscheduledata &&
                  <DataGrid rows={weeklyscheduledata}
                    columns={columns}
                    pageSize={5}
                    components={{ Toolbar: QuickSearchToolbar }}
                  />

                }
              </Box>
            </TabPanel>
            <TabPanel value="PlantUnloading" >
              <Box style={{ height: 400, width: '100%' }}>
                {
                  weeklyscheduledata &&
                  <DataGrid rows={weeklyscheduledata}
                    columns={columns}
                    pageSize={5}
                    components={{ Toolbar: QuickSearchToolbar }}
                  />

                }
              </Box>
            </TabPanel>
          </TabContext>
        </Card>
      </Container>
    </>
  )
}
export default PlantSchedule;